import { render, staticRenderFns } from "./StockInventoryList.vue?vue&type=template&id=168b6a68&scoped=true&"
import script from "./StockInventoryList.vue?vue&type=script&lang=js&"
export * from "./StockInventoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b6a68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168b6a68')) {
      api.createRecord('168b6a68', component.options)
    } else {
      api.reload('168b6a68', component.options)
    }
    module.hot.accept("./StockInventoryList.vue?vue&type=template&id=168b6a68&scoped=true&", function () {
      api.rerender('168b6a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/stock/stock-inventory/StockInventoryList.vue"
export default component.exports